import { permission } from './permission/index';
import { blur } from './blur/index';

export default {
  install(app: TypeObject): void {
    app.directive('permission', permission);
    app.directive('blur', blur);
  },
};
